module.exports = __webpack_public_path__ + "img/l-01.9df25b3d.png";